const FIRST_STRONG_ISOLATE = '⁨';
const POP_DIRECTIONAL_ISOLATE = '⁩';

/**
 * Sets apart a name or a text someone typed before it goes into a sentence: written in Arabic or Hebrew, it would
 * otherwise pull the words around it into its own direction. JSX isolates with `<bdi>`; a translated sentence, which
 * is one string, with these marks.
 */
export const isolateDirection = (text: string): string =>
    `${FIRST_STRONG_ISOLATE}${text}${POP_DIRECTIONAL_ISOLATE}`;
